import { useResolvedDesignSystemComponent } from 'ext-ui/design-system/DesignSystemChannel'
import GeneratedLatestButtonGroup, {
  ButtonGroupProps,
} from 'ext-ui/design-system/generated/latest/components/ButtonGroup/ButtonGroup'
import GeneratedLiveButtonGroup from 'ext-ui/design-system/generated/live/components/ButtonGroup/ButtonGroup'
import React, { ReactElement } from 'react'

function renderDesignSystemButtonGroup(
  Component: typeof GeneratedLiveButtonGroup,
  channel: 'live' | 'latest',
  props: ButtonGroupProps,
): ReactElement {
  return <Component {...props} data-design-system-channel={channel} />
}

function LiveButtonGroup(props: ButtonGroupProps): ReactElement {
  return renderDesignSystemButtonGroup(GeneratedLiveButtonGroup, 'live', props)
}

function LatestButtonGroup(props: ButtonGroupProps): ReactElement {
  return renderDesignSystemButtonGroup(
    GeneratedLatestButtonGroup,
    'latest',
    props,
  )
}

function ButtonGroup(props: ButtonGroupProps): ReactElement {
  const ResolvedButtonGroup = useResolvedDesignSystemComponent(
    LiveButtonGroup,
    LatestButtonGroup,
  )

  return <ResolvedButtonGroup {...props} />
}

export default ButtonGroup
export type { ButtonGroupProps }
